import 'cross-fetch/polyfill'
import { constants } from '../constants'
import instance from './apollo'
import gql from 'graphql-tag'
import { handleApolloResponse } from '../store/action/graphql.action'

export default class ApolloClientService {
  async getCustomersIdAndNameList(input) {
    const data = await instance.query({
      query: gql`
        query GetCustomersIdAndNameList(
          $input: getCompanyCustomersIdAndNameListInput
        ) {
          getCustomersIdAndNameList(input: $input) {
            status
            message
            customers {
              name
              id
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getCustomersIdAndNameList)
      : { err: 'getCustomersIdAndNameList failed, response not received' }
  }

  async createNewCase(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation createNewCase($input: CaseCreationByPatient) {
          createNewCase(input: $input) {
            status
            message
            caseid
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------createNewCase--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.createNewCase)
      : { err: 'createNewCase failed, response not received' }
  }

  async fetchCases(input) {
    console.log('fetchCases params --------->> ', input)

    const data = await instance.query({
      query: gql`
        query GetActionCaseList($input: getActionCaseListInput) {
          getActionCaseList(input: $input) {
            status
            total
            status
            actionCases {
              _id
              reportedBy
              reportedUsername
              patientName
              caseId
              caseNumber
              title
              summary
              description
              priority
              status
              lastViewedDate
              createdDate
              updatedDate
              lastUpdated
              patientId
              patientLastDigitOfPhone
              patientPhone
              customerId
              customerName
              assignedTo
              assignedToName
              isNew
              surgeon {
                _id
                image
                name
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('apolo', data.data)
    return data.data
      ? handleApolloResponse(data.data.getActionCaseList)
      : { err: 'getActionCase failed, response not received' }
  }

  async getPatientMessages(input) {
    const data = await instance.query({
      query: gql`
        query getPatientMessages($input: getActionCaseListInput) {
          getPatientMessages(input: $input) {
            status
            data {
              messages {
                _id
                reportedBy
                reportedUsername
                caseId
                caseNumber
                title
                description
                summary
                priority
                status
                lastViewedDate
                createdDate
                updatedDate
                patientId
                patientLastDigitOfPhone
                customerId
                customerName
                assignedTo
                assignedToName
                patientName
                isNew
                lastUpdated
                newCommentCount
                imageUrl {
                  original
                  thumbnail
                }
                comments {
                  _id
                  userid
                  comment
                  commented_date
                  userName
                  priority
                  imageUrl {
                    original
                    thumbnail
                  }
                }
                surgeon {
                  _id
                  image
                  name
                }
              }
              patient {
                _id
                firstname
                lastname
                phone
                email
                age
                lastdigitsofphone
                dob
                lastLoggedinTime
                gender
                surgery {
                  date
                  type
                }
                surgeon {
                  _id
                  name
                }
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('apolo', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientMessages)
      : { err: 'getPatientMessages failed, response not received' }
  }

  async getHealthCoachNameList(input) {
    const data = await instance.query({
      query: gql`
        query GetCompanyHealthcoach($input: SurgeonPagination!) {
          getCompanyHealthcoach(input: $input) {
            message
            total
            users {
              _id
              firstname
              lastname
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getCompanyHealthcoach)
      : { err: 'getActionCase failed, response not received' }
  }

  async isNewActionCase(customerid, surgeonId, companyId) {
    try {
      const data = await instance.query({
        query: gql`
          query isNewActionCase(
            $customerid: String
            $surgeonId: String
            $companyId: String
          ) {
            isNewActionCase(
              customerid: $customerid
              surgeonId: $surgeonId
              companyId: $companyId
            ) {
              isNew
              status
            }
          }
        `,
        variables: {
          customerid,
          surgeonId,
          companyId,
        },
        fetchPolicy: 'no-cache',
      })

      return data.data
        ? data.data.isNewActionCase
        : { err: 'isNewActionCase failed, response not received' }
    } catch (err) {
      console.log(err, 'Errorr')
    }
  }
  async deleteActionCase(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteActionCase($input: [String]) {
          deleteActionCase(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteActionCase--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.deleteActionCase)
      : { err: 'deleteActionCase failed, response not received' }
  }
  async updateActionCase(input) {
    console.log('updateActionCase --------->> 1', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation UpdateActionCase($input: updateActionCase) {
          updateActionCase(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------updateActionCase--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.updateActionCase)
      : { err: 'updateActionCase failed, response not received' }
  }

  async bulkUpdateActionCases(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation BulkUpdateActionCases($input: bulkUpdateActionCases) {
          bulkUpdateActionCases(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.bulkUpdateActionCases)
      : { err: 'bulkUpdateActionCases failed, response not received' }
  }

  async deleteWorkLog(input) {
    console.log('deleteWorkLog --------->', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteWorkLog($input: deleteWorkLog) {
          deleteWorkLog(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteWorkLog--------', data.data)
    return data.data
      ? data.data.deleteWorkLog
      : { err: 'deleteWorkLog failed, response not received' }
  }

  async deleteComment(input) {
    console.log('deleteComment --------->', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteComment($input: deleteWorkLog) {
          deleteComment(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteComment--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.deleteComment)
      : { err: 'deleteComment failed, response not received' }
  }

  async editWorkLog(input) {
    console.log('editWorkLog --------->', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation editWorkLog($input: editWorkLog) {
          editWorkLog(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------editWorkLog--------', data.data)
    return data.data
      ? data.data.editWorkLog
      : { err: 'editWorkLog failed, response not received' }
  }

  async editComment(input) {
    console.log('editWorkLog --------->', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation editComment($input: editComment) {
          editComment(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------editComment--------', data.data)
    return data.data
      ? data.data.editComment
      : { err: 'editComment failed, response not received' }
  }

  async updateLastViewed(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation UpdateLastViewed($input: updateLastViewed!) {
          updateLastViewed(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------updateLastViewed--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.updateLastViewed)
      : { err: 'updateLastViewed failed, response not received' }
  }

  async addComment(input) {
    console.log('addComment --------->> 1', input)
    let data = await instance.mutate({
      mutation: gql`
        mutation AddNewComment($input: addComment) {
          addNewComment(input: $input) {
            status
            commentId
            comment
            commentedDate
            userName
            priority
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addComment--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addNewComment)
      : { err: 'addComment failed, response not received' }
  }

  async assignedToMoveAi(caseId) {
    let data = await instance.mutate({
      mutation: gql`
        mutation AssignedToMoveAi($caseId: String) {
          assignedToMoveAi(caseId: $caseId) {
            status
            message
          }
        }
      `,
      variables: {
        caseId,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------assignedToMoveAi--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.assignedToMoveAi)
      : { err: 'assignedToMoveAi failed, response not received' }
  }
  async getActionCase(caseId) {
    const data = await instance.query({
      query: gql`
        query GetActionCase($input: String) {
          getActionCase(caseId: $input) {
            status
            message
            data {
              caseId
              caseNumber
              caseTitle
              caseDescription
              priority
              status
              assignedTo
              customerId
              summary
              customerName
              patientId
              patientLastDigitOfPhone
              lastViewed
              createdDate
              updatedDate
              imageUrl {
                original
                thumbnail
              }
              comments {
                _id
                userid
                comment
                commented_date
                userName
                imageUrl {
                  original
                  thumbnail
                }
              }
              totalTimeSpent
              workLog {
                _id
                userId
                userName
                createdAt
                timeMin
                workDescription
              }
            }
          }
        }
      `,
      variables: {
        input: caseId,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getActionCase)
      : { err: 'getActionCase failed, response not received' }
  }
  async getMessageCase(caseId) {
    const data = await instance.query({
      query: gql`
        query getMessageCase($input: String) {
          getMessageCase(caseId: $input) {
            status
            message
            data {
              caseId
              caseNumber
              customerName
              caseTitle
              caseDescription
              priority
              lastViewed
              reportedBy
              reportedUsername
              updatedDate
              assignedTo
              totalTimeSpent
              workLog {
                _id
                userId
                userName
                createdAt
                timeMin
                workDescription
              }
              status
              summary
              createdDate
              imageUrl {
                original
                thumbnail
              }
              patientData {
                _id
                firstname
                lastname
                phone
                email
                age
                lastdigitsofphone
                gender
                surgery {
                  date
                  type
                }
              }
              comments {
                _id
                userid
                comment
                commented_date
                userName
                imageUrl {
                  original
                  thumbnail
                }
                priority
              }
            }
          }
        }
      `,
      variables: {
        input: caseId,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getMessageCase)
      : { err: 'getMessageCase failed, response not received' }
  }
  async getImageUrl(input) {
    let data = await instance.query({
      query: gql`
        query getImageUrl($input: getImageUrl) {
          getImageUrl(input: $input) {
            imageUrl
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getImageUrl)
      : { err: 'failed, response not received' }
  }

  async getWoundImages(patientid) {
    let data = await instance.query({
      query: gql`
        query GetWoundImages($patientid: String) {
          getWoundImages(patientid: $patientid) {
            status
            message
            images {
              _id
              createdDate
              imageUrl {
                original
                thumbnail
              }
            }
          }
        }
      `,
      variables: { patientid },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getWoundImages)
      : { err: 'failed, response not received' }
  }

  async getWoundImagesCount(patientid) {
    let data = await instance.query({
      query: gql`
        query GetWoundImagesCount($patientid: String) {
          getWoundImagesCount(patientid: $patientid)
        }
      `,
      variables: { patientid },
      fetchPolicy: 'no-cache',
    })
    return data && data.data ? data.data.getWoundImagesCount || 0 : 0
  }

  async login(input) {
    let data = await instance.query({
      query: gql`
        query loginUser($input: UserCredentials) {
          loginUser(input: $input) {
            token
            _id
            firstname
            lastname
            email
            userimage
            role
            signature
            customer {
              _id
              name
              company
              companyObj {
                name
              }
              logo
              autoimportevent
              accesscode
              istestclinic
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
            }
            company {
              _id
              name
              email
              phone
              autoimportevent
            }
            surgeon
            token
            status
            message
            lastlogintime
            patients_count
            filter
            # Set once the account passes 3 consecutive failed attempts — the
            # signin page then renders the Turnstile widget and sends
            # captchaToken on the next try. Gate 9 S7, 2026-09-04.
            captcha_required
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------loginUser--------', data.data)
    return data.data
      ? data.data.loginUser
      : { err: 'loginUser failed, response not received' }
  }

  async loginWithOtp(input) {
    let data = await instance.query({
      query: gql`
        query loginWithOtp($input: otpin) {
          loginWithOtp(input: $input) {
            trustToken
            exp
            _id
            firstname
            lastname
            email
            userimage
            role
            signature
            pagevisited
            customer {
              _id
              name
              company
              companyObj {
                name
              }
              logo
              autoimportevent
              accesscode
              istestclinic
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
            }
            company {
              _id
              name
              email
              phone
              autoimportevent
            }
            surgeon
            token
            status
            message
            lastlogintime
            patients_count
            filter
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------loginWithOtp--------', data.data)
    return data.data
      ? data.data.loginWithOtp
      : { err: 'loginWithOtp failed, response not received' }
  }

  async resendOtp(input) {
    let data = await instance.query({
      query: gql`
        query resendOtp($input: String) {
          resendOtp(input: $input) {
            _id
            firstname
            lastname
            email
            userimage
            role
            signature
            customer {
              _id
              name
              company
              companyObj {
                name
              }
              logo
              autoimportevent
              accesscode
              istestclinic
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
            }
            company {
              _id
              name
              email
              phone
              autoimportevent
            }
            surgeon
            token
            status
            lastlogintime
            patients_count
            filter
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------resendOtp--------', data.data)
    return data.data
      ? data.data.resendOtp
      : { err: 'resendOtp failed, response not received' }
  }

  async getPatientList(input) {
    let data = await instance.query({
      query: gql`
        query getPatientList($input: PatientCond) {
          getPatientList(input: $input) {
            patients {
              _id
              istestpatient
              language
              firstname
              lastname
              gender
              height
              phone
              surgeon
              patientactivity {
                deviceactivity {
                  lastactivity
                  futureactivity
                  inactive
                }
                exerciseactivity {
                  lastactivity
                  futureactivity
                  inactive
                }
                feedbackactivity {
                  lastactivity
                  futureactivity
                  inactive
                }
              }
              provider {
                _id
                firstname
              }
              surgery {
                date
                type
              }
              progress
              deviceprogress

              deviceschedule {
                lastscore {
                  deviceid
                  display_name
                  device_unit
                  device_metric
                  value
                  date
                }
                assigneddevices {
                  deviceid
                  display_name
                  isDeleted
                }
                device_summary {
                  display_name
                  devicesummary {
                    incompletedays
                    partialdays
                    completeddays
                    remainingdays
                  }
                }
              }
              feedschedule {
                _id
                lastscores {
                  painlevel
                  kneescore
                  koosjrscore
                  hoosjrscore
                  hipscore
                  flexion
                  extension
                  painleveldate
                  hipscoredate
                  koosjrscoredate
                  hoosjrscoredate
                  flexiondate
                  extensiondate
                  kneescoredate
                  forms {
                    formid
                    shortname
                    score
                    date
                  }
                }
              }
              latestRomTest {
                extension
                flexion
                date
              }
              lastDaySteps {
                total
                date
              }
              lastDayTemp {
                femur
                tibia
                date
              }
              exerciseschedule {
                summary {
                  incompletedays
                  completeddays
                  partialdays
                  remainingdays
                }
                lastexercise {
                  status
                  date
                }
              }
              createdAt
              lastActiveAt
              loginStatus
              tracpatchCalibration {
                calibratedAt
                lastAttemptAt
                lastOutcome
                legSide
              }
            }
            total
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatientList--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientList)
      : { err: 'getPatientList failed, response not received' }
  }

  async getPatientListForCompany(input) {
    let data = await instance.query({
      query: gql`
        query getPatientListForCompany($input: PatientCompany) {
          getPatientListForCompany(input: $input) {
            patients {
              _id
              firstname
              lastname
              phone
              healthcoach
              customer {
                _id
                name
                logo
                company
                # Clicking a result dispatches loginAsCustomer with THIS object,
                # which replaces the store's customer wholesale. Without
                # accesscode the header loses the clinic code until the clinic is
                # re-selected from the clinics list. See docs/BUGS.md.
                accesscode
              }
              surgeon {
                name
              }
              lastdigitsofphone
            }
            total
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatientList--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientListForCompany)
      : { err: 'getPatientListForCompany failed, response not received' }
  }
  async getRegisteredPatients(input) {
    let data = await instance.query({
      query: gql`
        query getRegisteredPatients($input: PatientCompany) {
          getRegisteredPatients(input: $input) {
            patients {
              _id
              firstname
              lastname
              age
              gender
              phone
              dob
              email
              height
              shipaddress {
                city
                state
                zip
                country
                addressline2
                addressline1
              }
              caregiver {
                name
                fname
                lname
                relationship
                phone
                email
              }
            }
            total
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getRegisteredPatients--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getRegisteredPatients)
      : { err: 'getRegisteredPatients failed, response not received' }
  }

  async deleteRegisteredPatient(id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteRegisteredPatient($id: String) {
          deleteRegisteredPatient(id: $id) {
            patients {
              _id
              firstname
              lastname
              age
              gender
              phone
              dob
              email
              height
              shipaddress {
                city
                state
                zip
                country
                addressline2
                addressline1
              }
              caregiver {
                name
                fname
                lname
                relationship
                phone
                email
              }
            }
            total
          }
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteRegisteredPatient--------', data.data)
    return data.data
      ? data.data.deleteRegisteredPatient
      : { err: 'deleteRegisteredPatient failed, response not received' }
  }

  async getSurgeonList(input) {
    let data = await instance.query({
      query: gql`
        query getSurgeonList($input: Customerid) {
          getSurgeonList(input: $input) {
            surgeons {
              _id
              name
              firstname
              lastname
              accesscode
              description
              phone {
                private
                public
              }
              team {
                _id
                name
                details
                order
              }
              hospital_name
              hospital_url
              department_name
              department_title
              about_me
              unreadcount
              showinlist
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSurgeonList--------', data.data)
    return data.data
      ? data.data.getSurgeonList
      : { err: 'getSurgeonList failed, response not received' }
  }

  async getAllFeedbackForms(input) {
    let data = await instance.query({
      query: gql`
        query getAllFeedbackForms($input: Customerid) {
          getAllFeedbackForms(input: $input) {
            forms {
              _id
              shortname
              image
              questions {
                questnumber
                question
                type
                options {
                  optnumber
                  option
                }
              }
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAllFeedbackForms--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getAllFeedbackForms)
      : { err: 'getAllFeedbackForms failed, response not received' }
  }

  async getPatientFeedSchedule(input) {
    let data = await instance.query({
      query: gql`
        query getPatientFeedSchedule($input: String) {
          getPatientFeedSchedule(input: $input) {
            forms {
              weekdays
              _id
              formid
              startdate
              enddate
              schedule
              scheduletype
              skiponsurgerydate
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatientFeedSchedule--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientFeedSchedule)
      : { err: 'getPatientFeedSchedule failed, response not received' }
  }

  async getDeafultFeedSchedule(input) {
    console.log(input, 'JUT')
    let data = await instance.query({
      query: gql`
        query getDeafultFeedSchedule($input: feedbackin) {
          getDeafultFeedSchedule(input: $input) {
            forms {
              weekdays
              _id
              formid
              startdate
              enddate
              schedule
              scheduletype
              skiponsurgerydate
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getDeafultFeedSchedule--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getDeafultFeedSchedule)
      : { err: 'getDeafultFeedSchedule failed, response not received' }
  }

  async changeUserPassword(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation changeUserPassword($input: newPassword) {
          changeUserPassword(input: $input) {
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------resetPassword--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.changeUserPassword)
      : { err: 'resetPassword failed, response not received' }
  }
  async deleteUserDeviceToken(userid) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteUserDeviceToken($userid: String) {
          deleteUserDeviceToken(userid: $userid) {
            status
          }
        }
      `,
      variables: {
        userid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteUserDeviceToken--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.deleteUserDeviceToken)
      : { err: 'deleteUserDeviceToken failed, response not received' }
  }
  async editFeedSchedule(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation editFeedSchedule($input: editfeedin) {
          editFeedSchedule(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------editFeedSchedule--------', data.data)
    return data.data
      ? data.data.editFeedSchedule
      : { err: 'editFeedSchedule failed, response not received' }
  }

  async setPassword(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation setPassword($input: newPassword) {
          setPassword(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------setPassword--------', data.data)
    return data.data
      ? data.data.setPassword
      : { err: 'setPassword failed, response not received' }
  }

  async checkPasswordLink(token) {
    let data = await instance.mutate({
      mutation: gql`
        mutation checkPasswordLink($token: String) {
          checkPasswordLink(token: $token) {
            status
            message
          }
        }
      `,
      variables: {
        token,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.checkPasswordLink
      : { err: 'checkPasswordLink failed, response not received' }
  }

  async setPatientPassword(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation resetPassword($input: ResetPassword) {
          resetPassword(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------setPatientPassword--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.resetPassword)
      : { err: 'setPatientPassword failed, response not received' }
  }

  async togglePatientStatus(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation togglePatientStatus($input: togglePatientStatusInput) {
          togglePatientStatus(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------togglePatientStatus--------', data.data)
    return data.data
      ? data.data.togglePatientStatus
      : { err: 'togglePatientStatus failed, response not received' }
  }

  async resetLoginFailedCount(patientId) {
    let data = await instance.mutate({
      mutation: gql`
        mutation resetLoginFailedCount($patientId: String) {
          resetLoginFailedCount(patientId: $patientId) {
            status
            message
          }
        }
      `,
      variables: {
        patientId,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------resetLoginFailedCount--------', data.data)
    return data.data
      ? data.data.resetLoginFailedCount
      : { err: 'resetLoginFailedCount failed, response not received' }
  }

  async sendPatientAuthLink(input) {
    let data = await instance.query({
      query: gql`
        query sendPatientAuthLink($input: sendLink) {
          sendPatientAuthLink(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------sendPatientAuthLink--------', data.data)
    return data.data
      ? data.data.sendPatientAuthLink
      : { err: 'sendPatientAuthLink failed, response not received' }
  }

  async sendMobileAppLink(input) {
    let data = await instance.query({
      query: gql`
        query sendMobileAppLink($input: sendLink) {
          sendMobileAppLink(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------sendMobileAppLink--------', data.data)
    return data.data
      ? data.data.sendMobileAppLink
      : { err: 'sendMobileAppLink failed, response not received' }
  }

  async getUserVisitedPages() {
    let data = await instance.query({
      query: gql`
        query getUserVisitedPages {
          getUserVisitedPages {
            status
            pagevisited
          }
        }
      `,
      fetchPolicy: 'no-cache',
    })
    console.log('--------getUserVisitedPages--------', data.data)
    return data.data
      ? data.data.getUserVisitedPages
      : { err: 'getUserVisitedPages failed, response not received' }
  }

  async deleteAccountRequest(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteAccountRequest($input: deleteRequest) {
          deleteAccountRequest(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteAccountRequest--------', data.data)
    return data.data
      ? data.data.deleteAccountRequest
      : { err: 'deleteAccountRequest failed, response not received' }
  }

  async sendResetPasswordLink(_id, email, captchaToken) {
    let data = await instance.mutate({
      mutation: gql`
        mutation resetUserPassword(
          $_id: String
          $email: String
          $captchaToken: String
        ) {
          resetUserPassword(
            _id: $_id
            email: $email
            captchaToken: $captchaToken
          ) {
            status
            message
            captcha_required
          }
        }
      `,
      variables: {
        _id,
        email,
        captchaToken,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------resetUserPassword--------', data.data)
    return data.data
      ? data.data.resetUserPassword
      : { err: 'resetUserPassword failed, response not received' }
  }

  async verifyActivityLinkOtp(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation verifyActivityLinkOtp($input: activityLinkOtp) {
          verifyActivityLinkOtp(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------verifyActivityLinkOtp--------', data.data)
    return data.data
      ? data.data.verifyActivityLinkOtp
      : { err: 'verifyActivityLinkOtp failed, response not received' }
  }

  async validPatientId(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation validPatientId($input: String) {
          validPatientId(input: $input) {
            status
            message
            token
            email
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------validPatientId--------', data.data)
    return data.data
      ? data.data.validPatientId
      : { err: 'validPatientId failed, response not received' }
  }

  async updateUserVisitedPages(page) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updateUserVisitedPages($page: String) {
          updateUserVisitedPages(page: $page) {
            status
            message
          }
        }
      `,
      variables: {
        page,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------updateUserVisitedPages--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.updateUserVisitedPages)
      : { err: 'updateUserVisitedPages failed, response not received' }
  }

  async sendNotifications(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation addNotifications($input: AddNotifications) {
            addNotifications(input: $input) {
              status
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------addNotifications--------', data.data)
      return data.data
        ? data.data.addNotifications
        : { err: 'addNotifications failed, response not received' }
    } catch (err) {
      console.log(err)
    }
  }
  async caregiverNotify(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation caregiverNotify($input: caregiverNotify) {
            caregiverNotify(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------caregiverNotify', data.data)
      return data.data
        ? data.data.caregiverNotify
        : { err: 'caregiverNotify failed, response not received' }
    } catch (err) {
      console.log(err)
    }
  }

  async sendMail(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation sendReportMail($input: MailInput) {
            sendReportMail(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------sendReportMail--------', data.data)
      return data.data
        ? data.data.sendReportMail
        : { err: 'sendReportMail failed, response not received' }
    } catch (err) {
      console.log(err)
    }
  }

  async getPatientStats(input) {
    let data = await instance.query({
      query: gql`
        query getPatientStats($input: Customerid) {
          getPatientStats(input: $input) {
            knee
            hip
            active
            status
            surgeryTypes {
              name
              count
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatientStats--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientStats)
      : { err: 'getPatientStats failed, response not received' }
  }

  async getActionCaseStats(input) {
    let data = await instance.query({
      query: gql`
        query getActionCaseStats($input: Customerid) {
          getActionCaseStats(input: $input) {
            status
            CaseStats {
              unassigned
              assigned
              unresolved
              resolved
              notanissue
              total
              unread
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCaseStats--------', data.data)
    return data.data
      ? data.data.getActionCaseStats
      : { err: 'getCaseStats failed, response not received' }
  }

  async updateSignature(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updateSignature($input: Signature) {
          updateSignature(input: $input) {
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------updateSignature--------', data.data)
    return data.data
      ? data.data.updateSignature
      : { err: 'updateSignature failed, response not received' }
  }

  async getSurgeons(input) {
    let data = await instance.query({
      query: gql`
        query getSurgeons($input: SurgeonPagination) {
          getSurgeons(input: $input) {
            surgeons {
              _id
              name
              firstname
              lastname
              accesscode
              description
              url
              email
              address
              image
              phone {
                private
                public
              }
              patients
              team {
                _id
                name
                details
                order
              }
              hospital_name
              hospital_url
              department_name
              department_title
              about_me
              welcomevideo
              welcomevideo_youtube_id
              welcomevideo_label
              welcomevideo_autoplay
            }
            total
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSurgeons--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getSurgeons)
      : { err: 'getSurgeons failed, response not received' }
  }

  async getAccessCode(input) {
    let data = await instance.query({
      query: gql`
        query getAccessCode {
          getAccessCode
        }
      `,
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAccessCode--------', data.data)
    return data.data
      ? data.data.getAccessCode
      : { err: 'getAccessCode failed, response not received' }
  }

  async getSurgeon(input) {
    let data = await instance.query({
      query: gql`
        query getSurgeonById($input: String!) {
          getSurgeonById(id: $input) {
            _id
            name
            firstname
            lastname
            accesscode
            description
            url
            email
            address
            image
            phone {
              private
              public
            }
            team {
              _id
              name
              details
              order
            }
            hospital_name
            hospital_url
            department_name
            department_title
            about_me
            welcomevideo
            welcomevideo_youtube_id
            welcomevideo_label
            welcomevideo_autoplay
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSurgeon--------', data.data)
    return data.data
      ? data.data.getSurgeonById
      : { err: 'getSurgeon failed, response not received' }
  }

  async addEditSurgeon(input, id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditSurgeon($input: SurgeonInput, $id: String) {
          addEditSurgeon(input: $input, id: $id) {
            status
            message
          }
        }
      `,
      variables: {
        input,
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEditSurgeon--------', data.data)
    return data.data
      ? data.data.addEditSurgeon
      : { err: 'addEditSurgeon failed, response not received' }
  }

  async removeSurgeons(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation removeSurgeons($input: [String]) {
          removeSurgeons(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------removeSurgeons--------', data.data)
    return data.data
      ? data.data.removeSurgeons
      : { err: 'removeSurgeons failed, response not received' }
  }

  async getUsers(input) {
    let data = await instance.query({
      query: gql`
        query getUsers($input: SurgeonPagination) {
          getUsers(input: $input) {
            users {
              _id
              firstname
              lastname
              email
              userimage
              associatesurgeons
              associatecustomers
              role
              active
              phone
            }
            total
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getUsers--------', data.data)

    return data.data
      ? handleApolloResponse(data.data.getUsers)
      : { err: 'getUsers failed, response not received' }
  }

  async getPatientsFourdigits(input) {
    let data = await instance.query({
      query: gql`
        query getPatientsFourdigits($input: String!) {
          getPatientsFourdigits(input: $input) {
            status
            data {
              lastdigitsofphone
              _id
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatientsFourdigits--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getUsers)
      : { err: 'getUsers failed, response not received' }
  }

  async getCompanyHealthcoach(input) {
    let data = await instance.query({
      query: gql`
        query getCompanyHealthcoach($input: SurgeonPagination!) {
          getCompanyHealthcoach(input: $input) {
            users {
              _id
              firstname
              lastname
              email
            }
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCompanyHealthcoach--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCompanyHealthcoach)
      : { err: 'getCompanyHealthcoachzz failed, response not received' }
  }
  async addEditUser(input, id) {
    console.log(input, id)
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditUser($input: UserInput, $id: String) {
          addEditUser(input: $input, id: $id) {
            status
            message
          }
        }
      `,
      variables: {
        input,
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEditUser--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addEditUser)
      : { err: 'addEditUser failed, response not received' }
  }

  async deleteUser(id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteUser($id: String!) {
          deleteUser(id: $id) {
            status
            message
          }
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.deleteUser)
      : { err: 'deleteUser failed, response not received' }
  }

  async putPatientOnHold(isNew, patientid) {
    console.log('PPO', patientid)
    let data = await instance.mutate({
      mutation: gql`
        mutation putPatientOnHold($isNew: Boolean!, $patientid: String!) {
          putPatientOnHold(isNew: $isNew, patientid: $patientid) {
            status
            message
          }
        }
      `,
      variables: {
        isNew,
        patientid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------putPatientOnHold--------', data.data)
    return data.data
      ? data.data.putPatientOnHold
      : { err: 'putPatientOnHold failed, response not received' }
  }
  async getActiveAssignedDevices(id) {
    let data = await instance.query({
      query: gql`
        query getActiveAssignedDevices($id: String!) {
          getActiveAssignedDevices(id: $id) {
            assigneddevices {
              name
              display_name
              isDeleted
              deviceid
              status
              configured
              tracking_link
              reorder_on
              shipped_on
              delivered_on
              returned_on
              requested_by
              media {
                image {
                  url
                  meta_data
                }
                video {
                  url
                  meta_data
                }
              }
              valueDesc {
                metric
                parameter
                unit
                valueIndex
                isOutput
              }
            }

            status
            message
          }
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getActiveAssignedDevices--------', data.data)
    return data.data && !data.errors
      ? handleApolloResponse(data.data.getActiveAssignedDevices)
      : { err: 'getActiveAssignedDevices failed, response not received' }
  }
  async getPatient(id) {
    let data = await instance.query({
      query: gql`
        query getPatient($id: String!) {
          getPatient(id: $id) {
            email_opt_in
            careplan
            customer {
              _id
              name
              logo
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
            }
            _id
            istestpatient
            language
            firstname
            lastname
            age
            gender
            consent
            registered
            height
            cases
            dob
            email
            phone
            active
            login_failed_count
            timezoneOffset
            include_devices
            technicalholdhistory {
              status
              holddate
              releasedate
            }
            shipaddress {
              city
              state
              zip
              country
              addressline2
              addressline1
            }
            caregiver {
              name
              fname
              lname
              relationship
              phone
              email
            }
            lastdigitsofphone
            surgery {
              date
              type
            }
            surgeon {
              _id
              name
              firstname
              lastname
            }
            healthcoach {
              _id
              firstname
              lastname
              email
            }
            deviceSchedule {
              patientid
              startdate
              enddate
              overall_summary {
                incompletedays
                partialdays
                completeddays
                remainingdays
              }
              device_summary {
                display_name
                devicesummary {
                  incompletedays
                  partialdays
                  completeddays
                  remainingdays
                }
              }
              assigneddevices {
                name
                display_name
                isDeleted
                deviceid
                status
                configured
                tracking_link
                reorder_on
                shipped_on
                delivered_on
                returned_on
                requested_by
                media {
                  image {
                    url
                    meta_data
                  }
                  video {
                    url
                    meta_data
                  }
                }
                valueDesc {
                  metric
                  parameter
                  unit
                  valueIndex
                  isOutput
                }
              }
              weeklydevice_summary {
                _id
                weekdate
                devices {
                  _id
                  display_name
                  deviceid
                  totaldays
                  completeddays
                }
              }

              devicedateschedule {
                date
                devices {
                  display_name
                  deviceid
                  time
                  status
                  valueDesc {
                    metric
                    parameter
                    unit
                    valueIndex
                    isOutput
                  }
                  timesheet {
                    time
                    status
                    measurement {
                      time
                      values
                      history {
                        time
                        values
                      }
                    }
                  }
                }
              }
              lastscore {
                deviceid
                display_name
                device_unit
                device_metric
                value
                date
              }
            }

            exerciseSchedule {
              enddate
              startdate
              summary {
                partialdays
                completeddays
                incompletedays
                remainingdays
              }
              weeklyactivity_summary {
                _id
                weekdate
                totaldays
                completeddays
              }
              exercisedateschedule {
                date
                exercises {
                  exerciseid
                  meta {
                    name
                    description
                    type
                  }
                  time
                  repeat
                  hold
                  set
                  status
                }
              }
              isEditable
            }
            feedbackSchedule {
              lastscores {
                hipscore
                kneescore
                koosjrscore
                painlevel
                flexion
                extension
                painleveldate
                hipscoredate
                flexiondate
                extensiondate
                kneescoredate
                koosjrscoredate
                forms {
                  formid
                  shortname
                }
              }
              weeklyfeedschedule {
                weekdate
                feedback {
                  formid
                  totaldays
                  completeddays
                }
              }
              feedbackdateschedule {
                _id
                date
                forms {
                  _id
                  submittime
                  meta {
                    complete
                    partial
                    name
                  }
                }
              }
              isEditable
            }
            eventSchedule {
              date
              message
              title
            }
            dailyshift {
              start {
                hour
                minute
              }
              end {
                hour
                minute
              }
            }
            progressTestGoalOverrides {
              week
              extension
              flexion
            }
            createdAt
            status
            message
          }
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPatient--------', data.data)
    return data.data && !data.errors
      ? handleApolloResponse(data.data.getPatient)
      : { err: 'getPatient failed, response not received' }
  }

  async getOksData(id) {
    let data = await instance.query({
      query: gql`
        query getOksData($id: String!) {
          getOksData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getOksData--------', data.data)
    return data.data
      ? data.data.getOksData
      : { err: 'getOksData failed, response not received' }
  }

  async getKoosJrData(id) {
    let data = await instance.query({
      query: gql`
        query getKoosJrData($id: String!) {
          getKoosJrData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getKoosJrData--------', data.data)
    return data.data
      ? data.data.getKoosJrData
      : { err: 'getKoosJrData failed, response not received' }
  }

  async getHoosJrData(id) {
    let data = await instance.query({
      query: gql`
        query getHoosJrData($id: String!) {
          getHoosJrData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.getHoosJrData
      : { err: 'getHoosJrData failed, response not received' }
  }

  async getPainData(id) {
    let data = await instance.query({
      query: gql`
        query getPainData($id: String!) {
          getPainData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getPainData--------', data.data)
    return data.data
      ? data.data.getPainData
      : { err: 'getPainData failed, response not received' }
  }

  // 'Pain Level' chart series — the legacy 'Pain Management' questionnaire.
  // Distinct from getPainData above, which returns the 0–10 'Pain Score' form.
  async getPainLevelData(id) {
    let data = await instance.query({
      query: gql`
        query getPainLevelData($id: String!) {
          getPainLevelData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.getPainLevelData
      : { err: 'getPainLevelData failed, response not received' }
  }

  async getFlexionData(id) {
    let data = await instance.query({
      query: gql`
        query getFlexionData($id: String!) {
          getFlexionData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getFlexionData--------', data.data)
    return data.data
      ? data.data.getFlexionData
      : { err: 'getFlexionData failed, response not received' }
  }

  async getExtensionData(id) {
    let data = await instance.query({
      query: gql`
        query getExtensionData($id: String!) {
          getExtensionData(id: $id)
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getExtensionData--------', data.data)
    return data.data
      ? data.data.getExtensionData
      : { err: 'getExtensionData failed, response not received' }
  }

  // Calibration history for the patient detail page. Paged — this grows without
  // bound for a patient who recalibrates often.
  async getTracpatchCalibrationHistory(patientid, limit = 25, skip = 0) {
    let data = await instance.query({
      query: gql`
        query getTracpatchCalibrationHistory($patientid: String!, $limit: Int, $skip: Int) {
          getTracpatchCalibrationHistory(patientid: $patientid, limit: $limit, skip: $skip) {
            status
            total
            data {
              sensor
              deviceName
              legSide
              outcome
              failureCode
              attemptedAt
            }
          }
        }
      `,
      variables: { patientid, limit, skip },
      fetchPolicy: 'no-cache',
    })
    return data.data?.getTracpatchCalibrationHistory
  }

  async getTracPatchROM(patientid) {
    let data = await instance.query({
      query: gql`
        query getTracPatchROM($patientid: String!) {
          getTracPatchROM(patientid: $patientid) {
            status
            data {
              _id
              startTime
              endTime
              flexion
              extension
              combinedQos
              is_rom_test
            }
          }
        }
      `,
      variables: { patientid },
      fetchPolicy: 'no-cache',
    })
    return data.data?.getTracPatchROM
  }

  async getTracPatchSteps(patientid, startDate, endDate) {
    let data = await instance.query({
      query: gql`
        query getTracPatchSteps($patientid: String!, $startDate: Date, $endDate: Date) {
          getTracPatchSteps(patientid: $patientid, startDate: $startDate, endDate: $endDate) {
            status
            data {
              _id
              startTime
              endTime
              steps
            }
          }
        }
      `,
      variables: { patientid, startDate, endDate },
      fetchPolicy: 'no-cache',
    })
    return data.data?.getTracPatchSteps
  }

  async getTracPatchTemperature(patientid) {
    let data = await instance.query({
      query: gql`
        query getTracPatchTemperature($patientid: String!) {
          getTracPatchTemperature(patientid: $patientid) {
            status
            data {
              _id
              recorded_at
              femur_temp_c
              tibia_temp_c
            }
          }
        }
      `,
      variables: { patientid },
      fetchPolicy: 'no-cache',
    })
    return data.data?.getTracPatchTemperature
  }

  async getTracpatchExerciseResults(patientid, exerciseId, startDate, endDate) {
    let data = await instance.query({
      query: gql`
        query getTracpatchExerciseResults(
          $patientid: String!
          $exerciseId: Int
          $startDate: Date
          $endDate: Date
        ) {
          getTracpatchExerciseResults(
            patientid: $patientid
            exerciseId: $exerciseId
            startDate: $startDate
            endDate: $endDate
          ) {
            status
            data {
              _id
              exerciseid
              exerciseId
              exerciseName
              completedAt
              repsCompleted
              requiredReps
              requiredSets
              peakExtension
              peakFlexion
              autoCompleted
              postOpWeek
            }
          }
        }
      `,
      variables: { patientid, exerciseId, startDate, endDate },
      fetchPolicy: 'no-cache',
    })
    return data.data?.getTracpatchExerciseResults
  }

  async addEvent(id, input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEvent($id: String!, $input: EventInput!) {
          addEvent(id: $id, input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        id,
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEvent--------', data.data)
    return data.data
      ? data.data.addEvent
      : { err: 'addEvent failed, response not received' }
  }

  async editcaregiver(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addeditCaregiver($input: Caregiverin!) {
          addeditCaregiver(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addeditCaregiver--------', data.data)
    return data.data
      ? data.data.addeditCaregiver
      : { err: 'addeditCaregiver failed, response not received' }
  }

  async edithealthcoach(patientid, healthcoachid) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addeditHealthcoach(
          $patientid: String
          $healthcoachid: String
        ) {
          addeditHealthcoach(
            patientid: $patientid
            healthcoachid: $healthcoachid
          ) {
            status
            message
          }
        }
      `,
      variables: {
        patientid,
        healthcoachid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addeditHealthcoach--------', data.data)
    return data.data
      ? data.data.addeditHealthcoach
      : { err: 'addeditHealthcoach failed, response not received' }
  }

  async editShipAddress(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addeditShipAddress($input: Shipaddressin!) {
          addeditShipAddress(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addeditShipAddress--------', data.data)
    return data.data
      ? data.data.addeditShipAddress
      : { err: 'addeditShipAddress failed, response not received' }
  }

  async getFormByScheduleSubId(_id) {
    let data = await instance.query({
      query: gql`
        query getFormByScheduleSubId($_id: String) {
          getFormByScheduleSubId(_id: $_id) {
            shortname
            patientname
            submittime
            score
            date
            questions {
              question
              questnumber
              options {
                option
                optnumber
                selected
                text
              }
            }
            status
          }
        }
      `,
      variables: {
        _id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getFormByScheduleSubId--------', data.data)
    return data.data
      ? data.data.getFormByScheduleSubId
      : { err: 'getFormByScheduleSubId failed, response not received' }
  }

  async addPatient(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addPatientAdmin($input: Patientin) {
          addPatientAdmin(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addPatient--------', data.data)
    return data.data
      ? data.data.addPatientAdmin
      : { err: 'addPatient failed, response not received' }
  }

  async getSurveyDetail(patientid) {
    let data = await instance.query({
      query: gql`
        query getSurveyDetail($patientid: String) {
          getSurveyDetail(patientid: $patientid) {
            hipscore
            kneescore
            kneescoredate
            painlevel
            painleveldate
            flexion
            flexiondate
            extension
            extensiondate
            feedbackdateschedule {
              _id
              date
              forms {
                _id
                formid
                answers {
                  questnumber
                  optnumber
                  text
                  group {
                    optnumber
                    text
                  }
                }
                score
                submittime
              }
            }
            forms {
              _id
              formid
              shortname
              date
              score
            }
            status
          }
        }
      `,
      variables: {
        patientid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSurveyDetail--------', data.data)
    return data.data
      ? data.data.getSurveyDetail
      : { err: 'getSurveyDetail failed, response not received' }
  }

  async getFormGraphData(customerid, range) {
    let data = await instance.query({
      query: gql`
        query getFormGraphData($customerid: String, $range: Date) {
          getFormGraphData(customerid: $customerid, range: $range) {
            oks {
              name
              total
              data {
                count
                date
              }
            }
            pain {
              name
              total
              data {
                count
                date
              }
            }
            rom {
              name
              total
              data {
                count
                date
              }
            }
            status
            message
          }
        }
      `,
      variables: {
        customerid,
        range,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getFormGraphData--------', data.data)
    return data.data
      ? data.data.getFormGraphData
      : { err: 'getFormGraphData failed, response not received' }
  }

  async getLast7Activities(customerid, range) {
    let data = await instance.query({
      query: gql`
        query getLast7Activities($customerid: String!, $range: Date!) {
          getLast7Activities(customerid: $customerid, range: $range) {
            skipped
            complete
            partial
            status
            message
          }
        }
      `,
      variables: {
        customerid,
        range,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getLast7Activities--------', data.data)
    return data.data
      ? data.data.getLast7Activities
      : { err: 'getLast7Activities failed, response not received' }
  }

  async updateDeviceSchedule(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updateDeviceSchedule($input: updateDeviceSchedule!) {
          updateDeviceSchedule(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data.updateDeviceSchedule == undefined
      ? { err: 'getAutoAssignedDevices failed, response not received' }
      : data.data.updateDeviceSchedule
  }

  async setUserDeviceToken(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation setUserDeviceToken($input: setUserDeviceToken!) {
          setUserDeviceToken(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? data.data.setUserDeviceToken
      : { err: 'failed, response not received' }
  }
  async getFullfillments(input) {
    try {
      let data = await instance.query({
        query: gql`
          query getFullfillments($input: getFullfillmentListInput) {
            getFullfillments(input: $input) {
              status
              message
              total
              data {
                _id
                patientName
                orderDate
                noOfDevice
                patientconsent
                consent
                registered
                isnew
                customer {
                  name
                  logo
                }
                surgery {
                  date
                  type
                }
                surgeon {
                  _id
                  name
                }
                cases {
                  _id
                  status
                  casenumber
                }
              }
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })

      return data.data
        ? data.data.getFullfillments
        : { err: 'getFullfillments failed, response not received' }
    } catch (error) {
      console.error('Error fetching fulfillments:', error)
      return { err: 'Error fetching fulfillments' }
    }
  }

  async getFullfillmentsCount(input) {
    try {
      let data = await instance.query({
        query: gql`
          query getFullfillmentsCount($input: String) {
            getFullfillmentsCount(input: $input) {
              status
              message
              data {
                shipped
                pending
              }
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })

      return data.data
        ? data.data.getFullfillmentsCount
        : { err: 'getFullfillmentsCount failed, response not received' }
    } catch (error) {
      console.error('Error fetching FullfillmentsCount:', error)
      return { err: 'Error fetching FullfillmentsCount' }
    }
  }

  async getFullfillmentViewDevices(id) {
    try {
      let data = await instance.query({
        query: gql`
          query getFullfillmentViewDevices($id: String) {
            getFullfillmentViewDevices(id: $id) {
              status
              message
              data {
                _id
                status
                gateway_id
                tracking_link
                isnew
                authorization_form_signed
                note
                address {
                  shipping_address
                  shipping_city
                  shipping_state
                  shipping_zip_code
                  country
                }
                shipping_name
                createdAt
                customer {
                  _id
                  name
                  company
                  companyObj {
                    name
                  }
                  logo
                }
                patient {
                  _id
                  firstname
                  lastname
                  age
                  gender
                  phone
                  active
                  consent
                  registered
                  patientconsent
                  shipaddress {
                    city
                    state
                    zip
                    country
                    addressline2
                    addressline1
                  }
                  caregiver {
                    name
                    fname
                    lname
                    relationship
                    phone
                    email
                  }

                  surgery {
                    date
                    type
                  }
                  surgeon {
                    _id
                    name
                    firstname
                    lastname
                  }
                  healthcoach {
                    _id
                    firstname
                    lastname
                    email
                  }
                }
                devices {
                  deviceid
                  note
                  status
                  statusDescription
                  meta_data
                  device_type
                  white_short
                  blue_short
                  leg_side
                  device {
                    name
                    hardware_uuid
                    fulfillment_request {
                      shipping_name
                      shipping_address
                      shipping_city
                      shipping_state
                      shipping_zip_code
                      country
                      shipping_tracking_link
                    }
                  }
                }
              }
            }
          }
        `,
        variables: { id },
        fetchPolicy: 'no-cache',
      })

      return data.data
        ? data.data.getFullfillmentViewDevices
        : { err: 'getFullfillmentViewDevices failed, response not received' }
    } catch (error) {
      console.error('Error fetching getFullfillmentViewDevices:', error)
      return { err: 'Error fetching getFullfillmentViewDevices' }
    }
  }

  async getLast7Measurements(customerid, range) {
    let data = await instance.query({
      query: gql`
        query getLast7Measurements($customerid: String!, $range: Date!) {
          getLast7Measurements(customerid: $customerid, range: $range) {
            measkipped
            meacomplete
            meapartial
            status
            message
          }
        }
      `,
      variables: {
        customerid,
        range,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getLast7Measurements--------', data.data)
    return data.data
      ? data.data.getLast7Measurements
      : { err: 'getLast7Measurements failed, response not received' }
  }

  async getAllDevices(patient) {
    let data = await instance.query({
      query: gql`
        query getAllDevices($patient: PatientCriteria) {
          getAllDevices(patient: $patient) {
            _id
            name
            display_name
            device_type
            media {
              image {
                url
              }
            }
            scheduled_criteria {
              start_date
              end_date
              time
              interval
              skiponsurgerydate
            }
          }
        }
      `,
      variables: {
        patient,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
    // return (data.data.getAllDevices == undefined)?
    // { 'err' : 'getAutoAssignedDevices failed, response not received'}: data.data;
  }
  async getAllCarePlans(input) {
    console.log('------------------------AllCarePlans--------------------')
    let data = await instance.query({
      query: gql`
        query getAllCarePlans($input: getcareplan) {
          getAllCarePlans(input: $input) {
            _id
            name
            description
            include_regimens
            deviceids {
              _id
              name
              display_name
              media {
                image {
                  url
                }
              }
            }
            scheduletemplate {
              deviceid
              surgerytype
            }
          }
        }
      `,
      variables: {
        input,
      },

      fetchPolicy: 'no-cache',
    })
    console.log('--------RecievedAllcarePlans--------\n', data)
    return data.data
    // return (data.data.getAllDevices == undefined)?
    //     { 'err' : 'getAutoAssignedDevices failed, response not received'}: data.data;
  }

  async getAutoAssignedRegimens(patient) {
    let data = await instance.query({
      query: gql`
        query getAutoAssignedRegimens($patient: Patientin!) {
          getAutoAssignedRegimens(patient: $patient) {
            regimens {
              _id
              name
              exerciseschedule {
                startdate
                enddate
                exercise {
                  _id
                  name
                  image
                }
                repeat
                hold
                interval
                time
                set
                nextexerciseid
                skiponsurgerydate
              }
            }
            status
            message
          }
        }
      `,
      variables: {
        patient,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAutoAssignedRegimens--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getAutoAssignedRegimens)
      : { err: 'getAutoAssignedRegimens failed, response not received' }
  }

  async getRegimens(filter) {
    let data = await instance.query({
      query: gql`
        query getRegimens($filter: RegInput) {
          getRegimens(input: $filter) {
            regimens {
              _id
              name
              exerciseschedule {
                _id
                startdate
                enddate
                exercise {
                  _id
                  name
                  image
                }
                repeat
                hold
                time
                set
                nextexerciseid
                skiponsurgerydate
              }
            }
            status
            message
          }
        }
      `,
      variables: {
        filter,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getRegimens--------', data.data)
    return data.data
      ? data.data.getRegimens
      : { err: 'getRegimens failed, response not received' }
  }

  async validatePatient(input) {
    let data = await instance.query({
      query: gql`
        query validatePatient($input: Patientin) {
          validatePatient(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------validatePatient--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.validatePatient)
      : { err: 'validatePatient failed, response not received' }
  }

  async getAllExercises(customerid) {
    let data = await instance.query({
      query: gql`
        query getAllExercises($customerid: String) {
          getAllExercises(customerid: $customerid) {
            status
            message
            exercises {
              _id
              name
              description
              image
              video
              imagesequence
              exerciseId
              type
              surgeryTypes {
                _id
                name
              }
              tracpatchConfig {
                posture
                mode
                extension_limit
                extension_low
                extension_high
                flexion_low
                flexion_high
                flexion_limit
                bandsRequired
                requiredReps
                requiredHoldSeconds
                requiredSets
                restAngle
                assetKind
                tierDefaults {
                  tier
                  weekFrom
                  weekTo
                  flexion_low
                  flexion_high
                  extension_low
                  extension_high
                  rep_milestone
                  reps
                }
                rep_milestone_by_week {
                  week
                  flexion_low
                  flexion_high
                  extension_low
                  extension_high
                  reps
                }
              }
            }
          }
        }
      `,
      variables: { customerid },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAllExercises--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getAllExercises)
      : { err: 'getAllExercises failed, response not received' }
  }

  // ---- Exercise Builder CRUD (MoveAI super-admin) ------------------------
  // The shared selection returned by create/update so the page can refresh a
  // row without a full re-query.
  async createExercise(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation createExerciseDefinition($input: ExerciseIn!) {
          createExerciseDefinition(input: $input) {
            status
            message
            exercise {
              _id
              name
              exerciseId
              type
            }
          }
        }
      `,
      variables: { input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.createExerciseDefinition
      : { err: 'createExercise failed, response not received' }
  }

  async updateExercise(_id, input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updateExerciseDefinition($_id: String!, $input: ExerciseIn!) {
          updateExerciseDefinition(_id: $_id, input: $input) {
            status
            message
            exercise {
              _id
              name
              exerciseId
              type
            }
          }
        }
      `,
      variables: { _id, input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.updateExerciseDefinition
      : { err: 'updateExercise failed, response not received' }
  }

  async deleteExercise(_id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteExerciseDefinition($_id: String!) {
          deleteExerciseDefinition(_id: $_id) {
            status
            message
          }
        }
      `,
      variables: { _id },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? data.data.deleteExerciseDefinition
      : { err: 'deleteExercise failed, response not received' }
  }

  async getRangeExercises(patientid, startdate, enddate) {
    let data = await instance.query({
      query: gql`
        query getDateRangeActivities(
          $patientid: String
          $startdate: Date
          $enddate: Date!
        ) {
          getDateRangeActivities(
            patientid: $patientid
            startdate: $startdate
            enddate: $enddate
          ) {
            data {
              total
              complete
              date
            }
            summary {
              _id
              weekdate
              totaldays
              completeddays
            }
            status
          }
        }
      `,
      variables: {
        patientid,
        startdate,
        enddate,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getRangeExercises--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getDateRangeActivities)
      : { err: 'getRangeExercises failed, response not received' }
  }

  async getPatientCompliance(input) {
    let data = await instance.query({
      query: gql`
        query getPatientCompliance($input: Compilanceinput) {
          getPatientCompliance(input: $input) {
            status
            overAllSummary {
              completed {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
              partially {
                count
                patientids
              }
            }
            exerciseSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
            measurementSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
            feedBackSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    console.log('--------getPatientCompliance--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientCompliance)
      : { err: 'getPatientCompliance failed, response not received' }
  }

  async getPatientComplianceExercise(input) {
    let data = await instance.query({
      query: gql`
        query getPatientComplianceExercise($input: Compilanceinput) {
          getPatientComplianceExercise(input: $input) {
            status
            exerciseSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    console.log('--------getPatientComplianceExercise--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getPatientComplianceExercise)
      : { err: 'getPatientComplianceExercise failed, response not received' }
  }

  async getPatientComplianceMeasurement(input) {
    let data = await instance.query({
      query: gql`
        query getPatientComplianceMeasurement($input: Compilanceinput) {
          getPatientComplianceMeasurement(input: $input) {
            status
            measurementSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    console.log('--------getPatientComplianceMeasurement--------', data.data)
    return data.data
      ? data.data.getPatientComplianceMeasurement
      : { err: 'getPatientComplianceMeasurement failed, response not received' }
  }

  async getPatientComplianceFeedback(input) {
    let data = await instance.query({
      query: gql`
        query getPatientComplianceFeedback($input: Compilanceinput) {
          getPatientComplianceFeedback(input: $input) {
            status
            feedBackSummary {
              completed {
                count
                patientids
              }
              partially {
                count
                patientids
              }
              incomplete {
                count
                patientids
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })

    console.log('--------getPatientComplianceFeedback--------', data.data)
    return data.data
      ? data.data.getPatientComplianceFeedback
      : { err: 'getPatientComplianceFeedback failed, response not received' }
  }

  async getConsentForm(customerid) {
    let data = await instance.query({
      query: gql`
        query getConsentForm($customerid: String) {
          getConsentForm(customerid: $customerid) {
            message
            forms {
              _id
              active
              title
              description
              view
              sequence
            }
          }
        }
      `,
      variables: {
        customerid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getConsentForm--------', data.data)
    return data.data
      ? data.data.getConsentForm
      : { err: 'getConsentForm failed, response not received' }
  }
  async updateDeviceOrder(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation updateDeviceOrder($input: updateDeviceOrderIn) {
            updateDeviceOrder(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------updateDeviceOrder--------', data.data)
      return data.data
        ? data.data.updateDeviceOrder
        : { err: 'updateDeviceOrder failed, response not received' }
    } catch (err) {
      console.log(err, 'updateDeviceOrder')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }
  async markAsShipped(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation markAsShipped($input: markAsShippedIn) {
            markAsShipped(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------markAsShipped--------', data.data)
      return data.data
        ? data.data.markAsShipped
        : { err: 'markAsShipped failed, response not received' }
    } catch (err) {
      console.log(err, 'markAsShipped')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }
  async updateTrackingLink(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation updateTrackingLink($input: updateTrackingLinkIn) {
            updateTrackingLink(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------updateTrackingLink--------', data.data)
      return data.data
        ? data.data.updateTrackingLink
        : { err: 'updateTrackingLink failed, response not received' }
    } catch (err) {
      console.log(err, 'updateTrackingLink')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }

  async updateGatewayId(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation updateGatewayId($input: updateGatewayIdIn) {
            updateGatewayId(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------updateGatewayId--------', data.data)
      return data.data
        ? data.data.updateGatewayId
        : { err: 'updateGatewayId failed, response not received' }
    } catch (err) {
      console.log(err, 'updateGatewayId')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }

  async updateTracPatchFulfillment(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation updateTracPatchFulfillment($input: updateTracPatchFulfillmentIn) {
            updateTracPatchFulfillment(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      return data.data
        ? data.data.updateTracPatchFulfillment
        : { err: 'updateTracPatchFulfillment failed, response not received' }
    } catch (err) {
      console.log(err, 'updateTracPatchFulfillment')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }

  async updateAddress(input) {
    try {
      let data = await instance.mutate({
        mutation: gql`
          mutation updateAddress($input: updateAddressIn) {
            updateAddress(input: $input) {
              status
              message
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------updateAddress--------', data.data)
      return data.data
        ? handleApolloResponse(data.data.updateAddress)
        : { err: 'updateAddress failed, response not received' }
    } catch (err) {
      console.log(err, 'updateAddress')
      return { status: constants.MESSAGE.FAIL, message: 'Network error' }
    }
  }
  async addCustomPatient(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation creatPatientAdmin($input: CustomPatientIn!) {
          creatPatientAdmin(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------creatPatientAdmin--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.creatPatientAdmin)
      : { err: 'creatPatientAdmin failed, response not received' }
  }

  async addRegisterPatient(input) {
    console.log(input, 'inputinputinputinputinput')
    let data = await instance.mutate({
      mutation: gql`
        mutation addRegisterPatient($input: RegisterationPatientin!) {
          addRegisterPatient(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addRegisterPatient--------', data.data)
    return data.data
      ? data.data.addRegisterPatient
      : { err: 'addRegisterPatient failed, response not received' }
  }

  async editPatient(input, id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation editPatient($input: Patientin, $id: String) {
          editPatient(input: $input, id: $id) {
            status
            message
          }
        }
      `,
      variables: {
        input,
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------editPatient--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.editPatient)
      : { err: 'editPatient failed, response not received' }
  }

  async getDeviceSchedule(patientid) {
    let data = await instance.query({
      query: gql`
        query getDeviceSchedule($patientid: String!) {
          getDeviceSchedule(patientid: $patientid) {
            patientid
            scheduletemplate {
              startdate
              enddate
              deviceid
              time
              interval
              skiponsurgerydate
            }
            assigneddevices {
              deviceid
              display_name
              media {
                image {
                  url
                }
              }
            }
          }
        }
      `,
      variables: {
        patientid,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? { status: 'success', ...data.data }
      : { err: 'getDevicesScheddule failed, response not received' }
  }

  async getSchedule(patientid) {
    let data = await instance.query({
      query: gql`
        query getSchedule($patientid: String!) {
          getSchedule(patientid: $patientid) {
            status
            message
            schedule {
              _id
              startdate
              enddate
              interval
              exercise {
                _id
                name
                image
                exerciseId
                type
                tracpatchConfig {
                  posture
                  mode
                  extension_limit
                  extension_low
                  extension_high
                  flexion_low
                  flexion_high
                  flexion_limit
                  bandsRequired
                  requiredReps
                  requiredHoldSeconds
                  restAngle
                  assetKind
                  tierDefaults {
                    tier
                    weekFrom
                    weekTo
                    flexion_low
                    flexion_high
                    extension_low
                    extension_high
                    rep_milestone
                    reps
                  }
                }
              }
              regimen {
                _id
                name
              }
              repeat
              hold
              time
              set
              nextexerciseid
              skiponsurgerydate
              tracpatchConfigOverrides {
                posture
                mode
                extension_limit
                extension_low
                extension_high
                flexion_low
                flexion_high
                flexion_limit
                bandsRequired
                requiredReps
                requiredHoldSeconds
                rep_milestone_by_week {
                  week
                  flexion_low
                  flexion_high
                  extension_low
                  extension_high
                  reps
                }
                restAngle
              }
            }
          }
        }
      `,
      variables: {
        patientid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSchedule--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getSchedule)
      : { err: 'getOksData failed, response not received' }
  }

  async editSchedule(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation editSchedule($input: CustomPatientIn!) {
          editSchedule(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------editSchedule--------', data.data)
    return data.data
      ? data.data.editSchedule
      : { err: 'editSchedule failed, response not received' }
  }

  async fetchCompanyCustomers(companyid) {
    let data = await instance.query({
      query: gql`
        query getCompanyCustomerList($companyid: String) {
          getCompanyCustomerList(companyid: $companyid) {
            customers {
              _id
              name
              associatehealthcoach {
                _id
                firstname
                lastname
                email
              }
            }
            status
          }
        }
      `,
      variables: {
        companyid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCompanyCustomerList--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCompanyCustomerList)
      : { err: 'getCompanyCustomer failed, response not received' }
  }

  async getCustomers(input) {
    let data = await instance.query({
      query: gql`
        query getCustomers($input: CustomerPagination!) {
          getCustomers(input: $input) {
            customers {
              _id
              name
              firstname
              lastname
              company
              patients
              accesscode
              logo
              istestclinic
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
              contact {
                name
                email
                phone
              }
              address {
                line1
                line2
                city
                state
                zip
              }
            }
            total
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCustomers--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCustomers)
      : { err: 'getCustomers failed, response not received' }
  }

  async getCustomers2(input) {
    let data = await instance.query({
      query: gql`
        query getCustomers2($input: CustomerPagination!) {
          getCustomers2(input: $input) {
            customers {
              unassigned
              assigned
              resolved
              unresolved
              notanissue
              _id
              name
              firstname
              lastname
              company
              patients
              accesscode
              logo
              istestclinic
              surgerytypes {
                _id
                name
                description
                issurgical
                active
              }
              key
              fullyCompliant
              partiallyCompliant
              notCompliant
              lastActivities {
                status
                skipped
                partial
                complete
              }
              lastMeasurements {
                measkipped
                meapartial
                meacomplete
                status
                message
              }

              last3daysInact
              contact {
                name
                email
                phone
              }
              address {
                line1
                line2
                city
                state
                zip
              }
            }
            total
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCustomers2--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCustomers2)
      : { err: 'getCustomers2 failed, response not received' }
  }

  async getCustomer(customerid) {
    let data = await instance.query({
      query: gql`
        query getCustomer($customerid: String!) {
          getCustomer(customerid: $customerid) {
            _id
            name
            firstname
            lastname
            company
            accesscode
            surgerytypes {
              _id
              name
              description
              issurgical
              active
            }
            contact {
              name
              email
              phone
            }
            address {
              line1
              line2
              city
              state
              zip
            }
            logo
            allowPatientToContactClinic
            allowPatientToSendWoundImages
            clinicContactMessage
            status
            message
          }
        }
      `,
      variables: {
        customerid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCustomer--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCustomer)
      : { err: 'getCustomer failed, response not received' }
  }

  async getUniqueCustomerCode() {
    let data = await instance.query({
      query: gql`
        query getUniqueCustomerCode {
          getUniqueCustomerCode {
            accesscode
          }
        }
      `,
      variables: {},
      fetchPolicy: 'no-cache',
    })
    console.log('--------getUniqueCustomerCode--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getUniqueCustomerCode)
      : { err: 'getUniqueCustomerCode failed, response not received' }
  }

  async getCustomerLogoAndName(customerid) {
    let data = await instance.query({
      query: gql`
        query getCustomerLogoAndName($customerid: String!) {
          getCustomerLogoAndName(customerid: $customerid) {
            name
            logo
            surgerytypes {
              _id
              name
              description
              issurgical
              active
            }
            status
            message
          }
        }
      `,
      variables: {
        customerid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCustomerLogoAndName--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCustomerLogoAndName)
      : { err: 'getCustomerLogoAndName failed, response not received' }
  }
  async addEditCustomer(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditCustomer($input: NewCustomer) {
          addEditCustomer(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEditCustomer--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addEditCustomer)
      : { err: 'addEditCustomer failed, response not received' }
  }

  async getCompanies(input) {
    let data = await instance.query({
      query: gql`
        query getCompanies($input: CompanyPagination!) {
          getCompanies(input: $input) {
            companies {
              _id
              name
              description
              phone
              email
              contact {
                name
                email
                phone
              }
              address {
                line1
                line2
                city
                state
                zip
              }
            }
            total
            status
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCompanies--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCompanies)
      : { err: 'getCompanies failed, response not received' }
  }

  async addEditCompany(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditCompany($input: NewCompany) {
          addEditCompany(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEditCompany--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addEditCompany)
      : { err: 'addEditCompany failed, response not received' }
  }

  async addEditSupportProfile(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditSupportProfile($input: NewSupportProfile) {
          addEditSupportProfile(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.addEditSupportProfile)
      : { err: 'addEditSupportProfile failed, response not received' }
  }

  async deleteSupportProfile(companyid, id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteSupportProfile($companyid: String!, $id: String!) {
          deleteSupportProfile(companyid: $companyid, id: $id) {
            status
            message
          }
        }
      `,
      variables: {
        companyid,
        id,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.deleteSupportProfile)
      : { err: 'deleteSupportProfile failed, response not received' }
  }

  async getCompany(companyid) {
    let data = await instance.query({
      query: gql`
        query getCompany($companyid: String!) {
          getCompany(companyid: $companyid) {
            _id
            name
            description
            phone
            email
            contact {
              name
              email
              phone
            }
            address {
              line1
              line2
              city
              state
              zip
            }
            supportprofiles {
              _id
              name
              email
              phone
              phonesupport
              timefrom
              timeto
              timezone
            }
            status
            message
          }
        }
      `,
      variables: {
        companyid,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCompany--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCompany)
      : { err: 'getCompany failed, response not received' }
  }

  async getPatientNotifications(input) {
    var isAdmin = true
    let data = await instance.query({
      query: gql`
        query getNotifications($input: PatientID, $isAdmin: Boolean) {
          getNotifications(input: $input, isAdmin: $isAdmin) {
            notifications {
              _id
              read
              archive
              date
              header
              message
              readat
              delieveredat
              sender {
                firstname
                lastname
              }
            }
            status
            message
          }
        }
      `,
      variables: {
        input,
        isAdmin,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getNotifications--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getNotifications)
      : { err: 'getNotifications failed, response not received' }
  }

  async addCallback(patientid, request) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addCallbackRequest($patientid: String, $request: NewRequest) {
          addCallbackRequest(patientid: $patientid, request: $request) {
            status
            message
            receivedon
          }
        }
      `,
      variables: {
        patientid,
        request,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addCallbackRequest--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addCallbackRequest)
      : { err: 'addCallbackRequest failed, response not received' }
  }

  async getCallbackRequests(filter) {
    let data = await instance.query({
      query: gql`
        query getCallbackRequests($filter: FilterRequest) {
          getCallbackRequests(filter: $filter) {
            requests {
              _id
              from
              phone
              message
              receivedon
              isOutsider
              patient {
                _id
                surgery {
                  date
                }
              }
              surgeon {
                name
                image
                lastlogintime
              }
            }
            total
            status
            message
          }
        }
      `,
      variables: {
        filter,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getCallbackRequests--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getCallbackRequests)
      : { err: 'getCallbackRequests failed, response not received' }
  }

  async deleteCallbackRequest(ids) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteCallbackRequest($ids: [String!]) {
          deleteCallbackRequest(ids: $ids) {
            status
            message
          }
        }
      `,
      variables: {
        ids,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteCallbackRequest--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.deleteCallbackRequest)
      : { err: 'deleteCallbackRequest failed, response not received' }
  }

  async getSurgeonImage(id) {
    let data = await instance.query({
      query: gql`
        query getSurgeonImage($id: String!) {
          getSurgeonImage(id: $id) {
            image
            status
            message
          }
        }
      `,
      variables: {
        id,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getSurgeonImage--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getSurgeonImage)
      : { err: 'getSurgeonImage failed, response not received' }
  }

  async getAllEvents(input) {
    let data = await instance.query({
      query: gql`
        query getAllEvents($input: MasterEventInput) {
          getAllEvents(input: $input) {
            events {
              _id
              title
              message
              date
            }
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAllEvents--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getAllEvents)
      : { err: 'getAllEvents failed, response not received' }
  }

  async getAllSurgeryTypes() {
    let data = await instance.query({
      query: gql`
        query getAllSurgeryTypes {
          getAllSurgeryTypes {
            types {
              _id
              name
            }
            status
            message
          }
        }
      `,
      variables: {},
      fetchPolicy: 'no-cache',
    })
    console.log('--------getAllSurgeryTypes--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.getAllSurgeryTypes)
      : { err: 'getAllSurgeryTypes failed, response not received' }
  }

  async addEditEvent(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addEditEvent($input: MasterEventInput) {
          addEditEvent(input: $input) {
            status
            message
            _id
            title
            date
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------addEditEvent--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.addEditEvent)
      : { err: 'addEditEvent failed, response not received' }
  }

  async bulkAddEditEvent(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation bulkAddEditEvent($input: MasterEventInput) {
          bulkAddEditEvent(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------bulkAddEditEvent--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.bulkAddEditEvent)
      : { err: 'bulkAddEditEvent failed, response not received' }
  }

  async deleteEvent(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deleteEvent($input: MasterEventInput) {
          deleteEvent(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------deleteEvent--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.deleteEvent)
      : { err: 'deleteEvent failed, response not received' }
  }

  async isEventUpdated(input) {
    let data = await instance.query({
      query: gql`
        query isEventUpdated($input: MasterEventInput) {
          isEventUpdated(input: $input) {
            status
            message
            isupdated
            time
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------isEventUpdated--------', data.data)
    return data.data
      ? data.data.isEventUpdated
      : { err: 'isEventUpdated failed, response not received' }
  }

  async getDifference(input) {
    let data = await instance.query({
      query: gql`
        query getDifference($input: MasterEventInput) {
          getDifference(input: $input) {
            status
            message
            differences {
              type
              name
              events {
                date
                parent {
                  message
                  _id
                  title
                  date
                }
                child {
                  message
                  _id
                  title
                  date
                }
                isAdded
                isSame
                isUpdated
                isDeleted
              }
            }
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------getDifference--------', data.data)
    return data.data
      ? data.data.getDifference
      : { err: 'getDifference failed, response not received' }
  }

  async importFromMaster(input) {
    console.log(input)
    let data = await instance.mutate({
      mutation: gql`
        mutation importFromMaster($input: MasterEventInput) {
          importFromMaster(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------importFromMaster--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.importFromMaster)
      : { err: 'importFromMaster failed, response not received' }
  }

  async discardEvents(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation discardEvents($input: MasterEventInput) {
          discardEvents(input: $input) {
            status
            message
          }
        }
      `,
      variables: {
        input,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------discardEvents--------', data.data)
    return data.data
      ? handleApolloResponse(data.data.discardEvents)
      : { err: 'discardEvents failed, response not received' }
  }

  async switchAutoImport(input, flag) {
    let data = await instance.mutate({
      mutation: gql`
        mutation switchAutoImport($input: MasterEventInput, $flag: Boolean!) {
          switchAutoImport(input: $input, flag: $flag) {
            status
            message
          }
        }
      `,
      variables: {
        input,
        flag,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------switchAutoImport--------', data.data)
    return data.data
      ? data.data.switchAutoImport
      : { err: 'switchAutoImport failed, response not received' }
  }

  async getGraphMeasurementData(graphIn) {
    console.log('graphdata', graphIn)
    let data = await instance.query({
      query: gql`
        query getGraphMeasurementData($graphIn: graphIn!) {
          getGraphMeasurementData(graphIn: $graphIn) {
            _id
            xAxisLable
            yAxisLable
            devicename
            yAxisRange {
              min
              max
            }
            data {
              reading
              valueIndex
              threshold {
                min
                max
              }
              values {
                x
                xTime
                y
              }
            }
          }
        }
      `,
      variables: {
        graphIn,
      },
      fetchPolicy: 'no-cache',
    })
    console.log('--------isEventUpdated--------', data.data)
    return data.data.getGraphMeasurementData
      ? { data: data.data.getGraphMeasurementData, status: 'success' }
      : { err: 'failed, response not received' }
  }
  async getRangeMeasurement(patientid, deviceid, startdate, enddate) {
    console.log(patientid, deviceid, startdate, enddate, 'dddddddddddd')
    let data = await instance.query({
      query: gql`
        query getRangeMeasurement(
          $patientid: String!
          $deviceid: String
          $startdate: Date
          $enddate: Date
        ) {
          getRangeMeasurement(
            patientid: $patientid
            deviceid: $deviceid
            startdate: $startdate
            enddate: $enddate
          ) {
            _id
            xAxisLable
            yAxisLable
            devicename
            yAxisRange {
              min
              max
            }
            data {
              reading
              valueIndex
              threshold {
                min
                max
              }
              values {
                x
                y
              }
            }
          }
        }
      `,
      variables: {
        patientid,
        deviceid,
        startdate,
        enddate,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data.getRangeMeasurement
      ? { status: 'success', ...data.data }
      : { err: 'getRangeMeasurement failed, response not received' }
  }

  async setWebToken(webtoken) {
    let data = await instance.query({
      query: gql`
        mutation setWebToken($webtoken: WebTokenInput!) {
          setWebToken(webtoken: $webtoken) {
            status
            message
            webtoken
          }
        }
      `,
      variables: {
        webtoken,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data.setWebToken
      ? { status: 'success', ...data.data }
      : { err: 'setWebToken failed, response not received' }
  }

  // Patient Notes Methods
  async getPatientNotesCount(patientId) {
    try {
      const data = await instance.query({
        query: gql`
          query getPatientNotesCount($patientId: String!) {
            getPatientNotesCount(patientId: $patientId) {
              count
              status
              message
            }
          }
        `,
        variables: { patientId },
        fetchPolicy: 'no-cache', // Force fresh query to bypass cache issues
      })
      return data.data
        ? handleApolloResponse(data.data.getPatientNotesCount)
        : { err: 'getPatientNotesCount failed, response not received' }
    } catch (error) {
      console.error('Apollo getPatientNotesCount error:', error)
      throw error
    }
  }

  async getPatientNotes(input) {
    const data = await instance.query({
      query: gql`
        query getPatientNotes($input: PatientNotesFilter) {
          getPatientNotes(input: $input) {
            status
            message
            total
            notes {
              _id
              patient_id
              notes
              category
              time_logged
              datetime
              created_by {
                _id
                firstname
                lastname
                email
              }
              created_at
              updated_at
            }
          }
        }
      `,
      variables: { input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getPatientNotes)
      : { err: 'getPatientNotes failed, response not received' }
  }

  async getPatientNotesCategories() {
    try {
      const data = await instance.query({
        query: gql`
          query getPatientNotesCategories {
            getPatientNotesCategories {
              status
              message
              categories {
                _id
                category_name
                category_description
                is_default
                active
                created_at
                updated_at
              }
            }
          }
        `,
        fetchPolicy: 'network-only',
      })
      return data.data
        ? handleApolloResponse(data.data.getPatientNotesCategories)
        : { err: 'getPatientNotesCategories failed, response not received' }
    } catch (error) {
      console.error('Error fetching patient notes categories:', error)
      return { status: 'error', message: error.message, categories: [] }
    }
  }

  async addPatientNote(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addPatientNote($input: PatientNoteInput) {
          addPatientNote(input: $input) {
            status
            message
            note {
              _id
              patient_id
              notes
              category
              time_logged
              datetime
              created_by {
                _id
                firstname
                lastname
                email
              }
              created_at
              updated_at
            }
          }
        }
      `,
      variables: { input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.addPatientNote)
      : { err: 'addPatientNote failed, response not received' }
  }

  async updatePatientNote(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updatePatientNote($input: PatientNoteInput) {
          updatePatientNote(input: $input) {
            status
            message
            note {
              _id
              patient_id
              notes
              category
              time_logged
              datetime
              created_by {
                _id
                firstname
                lastname
                email
              }
              created_at
              updated_at
            }
          }
        }
      `,
      variables: { input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.updatePatientNote)
      : { err: 'updatePatientNote failed, response not received' }
  }

  async deletePatientNote(id) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deletePatientNote($id: String!) {
          deletePatientNote(id: $id) {
            status
            message
          }
        }
      `,
      variables: { id },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.deletePatientNote)
      : { err: 'deletePatientNote failed, response not received' }
  }

  async getActivityLog(input) {
    try {
      let data = await instance.query({
        query: gql`
          query getActivityLog($input: getActivityLogInput) {
            getActivityLog(input: $input) {
              status
              activitylogs {
                createdAt
                patientid
                application
                actiontype
                action
                method
                lastActivityDate
                collection_name
                newdata
                olddata
              }
            }
          }
        `,
        variables: {
          input,
        },
        fetchPolicy: 'no-cache',
      })
      console.log('--------getActivityLog--------', data.data)
      return data.data
        ? handleApolloResponse(data.data.getActivityLog)
        : { err: 'getActivityLog failed, response not received' }
    } catch (error) {
      console.error('--------getActivityLog EXCEPTION--------', error)
      return { err: 'getActivityLog failed with exception: ' + error.message }
    }
  }

  async getExercise(exerciseId) {
    let data = await instance.query({
      query: gql`
        query getExercise($id: String!) {
          getExercise(id: $id) {
            _id
            name
            description
            exerciseId
            type
            tracpatchConfig {
              posture
              mode
              extension_limit
              extension_low
              extension_high
              flexion_low
              flexion_high
              flexion_limit
              bandsRequired
              requiredReps
              requiredHoldSeconds
              restAngle
              assetKind
              tierDefaults {
                tier
                weekFrom
                weekTo
                flexion_low
                flexion_high
                extension_low
                extension_high
                rep_milestone
                reps
              }
            }
          }
        }
      `,
      variables: {
        id: exerciseId,
      },
      fetchPolicy: 'cache-first',
    })
    return data.data?.getExercise || null
  }

  // Patient Diagnoses Methods
  async getPatientDiagnoses(patientId) {
    let data = await instance.query({
      query: gql`
        query getPatientDiagnoses($patientId: String!) {
          getPatientDiagnoses(patientId: $patientId) {
            status
            message
            data {
              _id
              patientId
              diagnoses {
                dxCode
                dxDescription
                addedAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      `,
      variables: {
        patientId,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getPatientDiagnoses)
      : { err: 'getPatientDiagnoses failed, response not received' }
  }

  // Billing Methods
  async getBillingData(patientId, month, year) {
    let data = await instance.query({
      query: gql`
        query getBillingData($patientId: String!, $month: Int!, $year: Int!) {
          getBillingData(patientId: $patientId, month: $month, year: $year) {
            status
            message
            data {
              patientId
              month
              year
              cpt99453 {
                qualifies
                totalTime
                deviceSetupNotes {
                  _id
                  category
                  time_logged
                  datetime
                  notes
                }
                assignedDevices {
                  display_name
                  deviceid
                  hwi_device_id
                }
              }
              cpt99454 {
                qualifies
                daysWithData
                measurementsByDevice {
                  device_name
                  hwi_device_id
                  measurements {
                    timestamp
                    metric
                    value_1
                    value_2
                  }
                }
              }
              cpt99457 {
                qualifies
                totalTime
                reviewNotes {
                  _id
                  category
                  time_logged
                  datetime
                  notes
                }
              }
            }
          }
        }
      `,
      variables: {
        patientId,
        month,
        year,
      },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getBillingData)
      : { err: 'getBillingData failed, response not received' }
  }

  async addSingleDiagnosis(patientId, input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addSingleDiagnosis(
          $patientId: String!
          $input: DiagnosisInput!
        ) {
          addSingleDiagnosis(patientId: $patientId, input: $input) {
            status
            message
            data {
              _id
              patientId
              diagnoses {
                dxCode
                dxDescription
                addedAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      `,
      variables: {
        patientId,
        input,
      },
    })
    return data.data
      ? handleApolloResponse(data.data.addSingleDiagnosis)
      : { err: 'addSingleDiagnosis failed, response not received' }
  }

  async updatePatientDiagnosis(patientId, input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation updatePatientDiagnosis(
          $patientId: String!
          $input: UpdateDiagnosisInput!
        ) {
          updatePatientDiagnosis(patientId: $patientId, input: $input) {
            status
            message
            data {
              _id
              patientId
              diagnoses {
                dxCode
                dxDescription
                addedAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      `,
      variables: {
        patientId,
        input,
      },
    })
    return data.data
      ? handleApolloResponse(data.data.updatePatientDiagnosis)
      : { err: 'updatePatientDiagnosis failed, response not received' }
  }

  async deletePatientDiagnosis(patientId, dxCode) {
    let data = await instance.mutate({
      mutation: gql`
        mutation deletePatientDiagnosis($patientId: String!, $dxCode: String!) {
          deletePatientDiagnosis(patientId: $patientId, dxCode: $dxCode) {
            status
            message
            data {
              _id
              patientId
              diagnoses {
                dxCode
                dxDescription
                addedAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      `,
      variables: {
        patientId,
        dxCode,
      },
    })
    return data.data
      ? handleApolloResponse(data.data.deletePatientDiagnosis)
      : { err: 'deletePatientDiagnosis failed, response not received' }
  }

  async addPatientDiagnoses(input) {
    let data = await instance.mutate({
      mutation: gql`
        mutation addPatientDiagnoses($input: PatientDiagnosesInput!) {
          addPatientDiagnoses(input: $input) {
            status
            message
            data {
              _id
              patientId
              diagnoses {
                dxCode
                dxDescription
                addedAt
                updatedAt
              }
              createdAt
              updatedAt
            }
          }
        }
      `,
      variables: {
        input,
      },
    })
    return data.data
      ? handleApolloResponse(data.data.addPatientDiagnoses)
      : { err: 'addPatientDiagnoses failed, response not received' }
  }

  async getActiveSurgeryTypes() {
    const data = await instance.query({
      query: gql`
        query GetActiveSurgeryTypes {
          getActiveSurgeryTypes {
            status
            message
            types {
              _id
              name
              description
              issurgical
              active
            }
          }
        }
      `,
      fetchPolicy: 'no-cache',
    })

    return data.data && data.data.getActiveSurgeryTypes
      ? data.data.getActiveSurgeryTypes.types
      : []
  }

  async getTncByVersion(version) {
    const data = await instance.query({
      query: gql`
        query getTncByVersion($version: String!) {
          getTncByVersion(version: $version) {
            status
            message
            tnc {
              _id
              version
              content
              active
              createdAt
            }
          }
        }
      `,
      variables: { version },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? data.data.getTncByVersion
      : { err: 'getTncByVersion failed, response not received' }
  }

  async getPatientConsentContent(patientid) {
    const data = await instance.query({
      query: gql`
        query getPatientConsentContent($patientid: String!) {
          getPatientConsentContent(patientid: $patientid) {
            status
            forms {
              formid
              title
              version
              content
              signature_time
            }
          }
        }
      `,
      variables: { patientid },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? data.data.getPatientConsentContent
      : { err: 'getPatientConsentContent failed, response not received' }
  }

  // ---- Clinic settings (key/value ClinicSettings collection) ----
  async getClinicSetting({ customerid, key }) {
    const data = await instance.query({
      query: gql`
        query getClinicSetting($customerid: String!, $key: String!) {
          getClinicSetting(customerid: $customerid, key: $key) {
            status
            message
            data {
              _id
              customerid
              key
              value
              updatedAt
            }
          }
        }
      `,
      variables: { customerid, key },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getClinicSetting)
      : { err: 'getClinicSetting failed, response not received' }
  }

  async updateClinicSetting({ customerid, key, value }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation updateClinicSetting(
          $customerid: String!
          $key: String!
          $value: JSON!
        ) {
          updateClinicSetting(customerid: $customerid, key: $key, value: $value) {
            status
            message
            data {
              _id
              customerid
              key
              value
              updatedAt
            }
          }
        }
      `,
      variables: { customerid, key, value },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.updateClinicSetting)
      : { err: 'updateClinicSetting failed, response not received' }
  }

  async resetClinicSetting({ customerid, key }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation resetClinicSetting($customerid: String!, $key: String!) {
          resetClinicSetting(customerid: $customerid, key: $key) {
            status
            message
          }
        }
      `,
      variables: { customerid, key },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.resetClinicSetting)
      : { err: 'resetClinicSetting failed, response not received' }
  }

  // ---- Company-level settings: what a NEW clinic of the company starts from ----
  async getCompanySetting({ companyid, key }) {
    const data = await instance.query({
      query: gql`
        query getCompanySetting($companyid: String!, $key: String!) {
          getCompanySetting(companyid: $companyid, key: $key) {
            status
            message
            data {
              _id
              companyid
              key
              value
              updatedAt
            }
          }
        }
      `,
      variables: { companyid, key },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getCompanySetting)
      : { err: 'getCompanySetting failed, response not received' }
  }

  async updateCompanySetting({ companyid, key, value }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation updateCompanySetting(
          $companyid: String!
          $key: String!
          $value: JSON!
        ) {
          updateCompanySetting(companyid: $companyid, key: $key, value: $value) {
            status
            message
            data {
              _id
              companyid
              key
              value
              updatedAt
            }
          }
        }
      `,
      variables: { companyid, key, value },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.updateCompanySetting)
      : { err: 'updateCompanySetting failed, response not received' }
  }

  async resetCompanySetting({ companyid, key }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation resetCompanySetting($companyid: String!, $key: String!) {
          resetCompanySetting(companyid: $companyid, key: $key) {
            status
            message
          }
        }
      `,
      variables: { companyid, key },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.resetCompanySetting)
      : { err: 'resetCompanySetting failed, response not received' }
  }

  // ---- Coded reminders (layered `reminders` catalog: system/company/clinic) ----
  // The languages the platform serves (server config). Editors that author
  // translations build one field set per non-default language from this.
  async supportedLanguages() {
    const data = await instance.query({
      query: gql`
        query supportedLanguages {
          supportedLanguages {
            code
            label
            nativeLabel
            isDefault
          }
        }
      `,
      fetchPolicy: 'cache-first',
    })
    return data.data && data.data.supportedLanguages
      ? data.data.supportedLanguages
      : []
  }

  async remindersForCompany({ companyid }) {
    const data = await instance.query({
      query: gql`
        query remindersForCompany($companyid: String!) {
          remindersForCompany(companyid: $companyid) {
            status
            message
            data {
              reminder_code
              scope
              effectiveScope
              companyid
              customerid
              name
              title
              message
              i18n
              category
              channels
              trigger
              quietHours
              smsType
              surgeryType
              notifyCaregiver
              active
              updatedAt
            }
          }
        }
      `,
      variables: { companyid },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.remindersForCompany)
      : { err: 'remindersForCompany failed, response not received' }
  }

  async remindersForClinic({ customerid }) {
    const data = await instance.query({
      query: gql`
        query remindersForClinic($customerid: String!) {
          remindersForClinic(customerid: $customerid) {
            status
            message
            data {
              reminder_code
              scope
              effectiveScope
              companyid
              customerid
              name
              title
              message
              i18n
              category
              channels
              trigger
              quietHours
              smsType
              surgeryType
              notifyCaregiver
              active
              isCustom
              updatedAt
            }
          }
        }
      `,
      variables: { customerid },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.remindersForClinic)
      : { err: 'remindersForClinic failed, response not received' }
  }

  async upsertCompanyReminder({ companyid, input }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation upsertCompanyReminder($companyid: String!, $input: ReminderInput!) {
          upsertCompanyReminder(companyid: $companyid, input: $input) {
            status
            message
            data {
              reminder_code
              scope
              active
            }
          }
        }
      `,
      variables: { companyid, input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.upsertCompanyReminder)
      : { err: 'upsertCompanyReminder failed, response not received' }
  }

  async deleteCompanyReminder({ companyid, reminder_code }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation deleteCompanyReminder($companyid: String!, $reminder_code: String!) {
          deleteCompanyReminder(companyid: $companyid, reminder_code: $reminder_code) {
            status
            message
          }
        }
      `,
      variables: { companyid, reminder_code },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.deleteCompanyReminder)
      : { err: 'deleteCompanyReminder failed, response not received' }
  }

  async upsertClinicReminder({ customerid, input }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation upsertClinicReminder($customerid: String!, $input: ReminderInput!) {
          upsertClinicReminder(customerid: $customerid, input: $input) {
            status
            message
            data {
              reminder_code
              scope
              active
            }
          }
        }
      `,
      variables: { customerid, input },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.upsertClinicReminder)
      : { err: 'upsertClinicReminder failed, response not received' }
  }

  async deleteClinicReminder({ customerid, reminder_code }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation deleteClinicReminder($customerid: String!, $reminder_code: String!) {
          deleteClinicReminder(customerid: $customerid, reminder_code: $reminder_code) {
            status
            message
          }
        }
      `,
      variables: { customerid, reminder_code },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.deleteClinicReminder)
      : { err: 'deleteClinicReminder failed, response not received' }
  }

  async resetClinicReminders({ customerid }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation resetClinicReminders($customerid: String!) {
          resetClinicReminders(customerid: $customerid) {
            status
            message
          }
        }
      `,
      variables: { customerid },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.resetClinicReminders)
      : { err: 'resetClinicReminders failed, response not received' }
  }

  // ---- Maintenance mode (SUPER_ADMIN System Maintenance page) ----
  async getMaintenanceMode() {
    const data = await instance.query({
      query: gql`
        query getMaintenanceMode {
          getMaintenanceMode {
            status
            message
            data {
              enabled
              message
              startedAt
              endedAt
            }
          }
        }
      `,
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getMaintenanceMode)
      : { err: 'getMaintenanceMode failed, response not received' }
  }

  async setMaintenanceMode({ enabled, message }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation setMaintenanceMode($enabled: Boolean!, $message: String) {
          setMaintenanceMode(enabled: $enabled, message: $message) {
            status
            message
            data {
              enabled
              message
              startedAt
              endedAt
            }
          }
        }
      `,
      variables: { enabled, message },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.setMaintenanceMode)
      : { err: 'setMaintenanceMode failed, response not received' }
  }

  async getActiveUsers({ windowMinutes }) {
    const data = await instance.query({
      query: gql`
        query getActiveUsers($windowMinutes: Int) {
          getActiveUsers(windowMinutes: $windowMinutes) {
            status
            message
            total
            data {
              _id
              name
              usertype
              role
              clinic
              lastActiveAt
            }
          }
        }
      `,
      variables: { windowMinutes },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getActiveUsers)
      : { err: 'getActiveUsers failed, response not received' }
  }

  async getDefaultCarePlanSurgeryTypes({ customerid }) {
    const data = await instance.query({
      query: gql`
        query getDefaultCarePlanSurgeryTypes($customerid: String!) {
          getDefaultCarePlanSurgeryTypes(customerid: $customerid) {
            _id
            name
          }
        }
      `,
      variables: { customerid },
      fetchPolicy: 'no-cache',
    })

    return data.data && data.data.getDefaultCarePlanSurgeryTypes
      ? data.data.getDefaultCarePlanSurgeryTypes
      : []
  }

  // ---- Company default care plan (the template a NEW clinic is created from) ----
  async getCompanyCarePlanSurgeryTypes({ companyid }) {
    const data = await instance.query({
      query: gql`
        query getCompanyCarePlanSurgeryTypes($companyid: String!) {
          getCompanyCarePlanSurgeryTypes(companyid: $companyid) {
            _id
            name
          }
        }
      `,
      variables: { companyid },
      fetchPolicy: 'no-cache',
    })
    return data.data && data.data.getCompanyCarePlanSurgeryTypes
      ? data.data.getCompanyCarePlanSurgeryTypes
      : []
  }

  async getCompanyCarePlan({ companyid, surgeryType }) {
    const data = await instance.query({
      query: gql`
        query getCompanyCarePlan($companyid: String!, $surgeryType: String!) {
          getCompanyCarePlan(companyid: $companyid, surgeryType: $surgeryType) {
            surgeryType
            regimenId
            status
            message
            feedback {
              formid
              startdate
              enddate
              interval
              skiponsurgerydate
            }
            exercises {
              exerciseid
              startdate
              enddate
              set
              repeat
              hold
              interval
              skiponsurgerydate
            }
            devices {
              deviceid
              startdate
              enddate
              interval
              time
              skiponsurgerydate
            }
            formCatalog {
              _id
              shortname
            }
            exerciseCatalog {
              _id
              name
              exerciseId
              type
              requiredSets
              requiredReps
            }
            deviceCatalog {
              _id
              name
              display_name
              device_type
            }
          }
        }
      `,
      variables: { companyid, surgeryType },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.getCompanyCarePlan)
      : { err: 'getCompanyCarePlan failed, response not received' }
  }

  async updateCompanyCarePlan({ companyid, surgeryType, feedback, exercises, devices }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation updateCompanyCarePlan(
          $companyid: String!
          $surgeryType: String!
          $feedback: [DcpFeedbackIn!]!
          $exercises: [DcpExerciseIn!]!
          $devices: [DcpDeviceIn!]!
        ) {
          updateCompanyCarePlan(
            companyid: $companyid
            surgeryType: $surgeryType
            feedback: $feedback
            exercises: $exercises
            devices: $devices
          ) {
            status
            message
          }
        }
      `,
      variables: { companyid, surgeryType, feedback, exercises, devices },
      fetchPolicy: 'no-cache',
    })
    return data.data
      ? handleApolloResponse(data.data.updateCompanyCarePlan)
      : { err: 'updateCompanyCarePlan failed, response not received' }
  }

  async getDefaultCarePlan({ customerid, surgeryType }) {
    const data = await instance.query({
      query: gql`
        query getDefaultCarePlan($customerid: String!, $surgeryType: String!) {
          getDefaultCarePlan(customerid: $customerid, surgeryType: $surgeryType) {
            surgeryType
            regimenId
            status
            message
            feedback {
              formid
              startdate
              enddate
              interval
              skiponsurgerydate
            }
            exercises {
              exerciseid
              startdate
              enddate
              set
              repeat
              hold
              interval
              skiponsurgerydate
            }
            devices {
              deviceid
              startdate
              enddate
              interval
              time
              skiponsurgerydate
            }
            formCatalog {
              _id
              shortname
            }
            exerciseCatalog {
              _id
              name
              exerciseId
              type
              requiredSets
              requiredReps
            }
            deviceCatalog {
              _id
              name
              display_name
              device_type
            }
          }
        }
      `,
      variables: { customerid, surgeryType },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.getDefaultCarePlan)
      : { err: 'getDefaultCarePlan failed, response not received' }
  }

  async updateDefaultCarePlan({ customerid, surgeryType, feedback, exercises, devices }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation updateDefaultCarePlan(
          $customerid: String!
          $surgeryType: String!
          $feedback: [DcpFeedbackIn!]!
          $exercises: [DcpExerciseIn!]!
          $devices: [DcpDeviceIn!]!
        ) {
          updateDefaultCarePlan(
            customerid: $customerid
            surgeryType: $surgeryType
            feedback: $feedback
            exercises: $exercises
            devices: $devices
          ) {
            status
            message
          }
        }
      `,
      variables: { customerid, surgeryType, feedback, exercises, devices },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.updateDefaultCarePlan)
      : { err: 'updateDefaultCarePlan failed, response not received' }
  }

  // Clinic Settings "Reset to company care plan" (templates, TracPatch
  // settings, Progress Test Goals, reminders — as at clinic creation).
  async resetClinicToCompanyCarePlan({ customerid }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation resetClinicToCompanyCarePlan($customerid: String!) {
          resetClinicToCompanyCarePlan(customerid: $customerid) {
            status
            message
          }
        }
      `,
      variables: { customerid },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.resetClinicToCompanyCarePlan)
      : { err: 'resetClinicToCompanyCarePlan failed, response not received' }
  }

  // The care-plan panel's own Reset: one surgery type back to the company plan.
  async resetClinicCarePlan({ customerid, surgeryType }) {
    const data = await instance.mutate({
      mutation: gql`
        mutation resetClinicCarePlan($customerid: String!, $surgeryType: String!) {
          resetClinicCarePlan(customerid: $customerid, surgeryType: $surgeryType) {
            status
            message
          }
        }
      `,
      variables: { customerid, surgeryType },
      fetchPolicy: 'no-cache',
    })

    return data.data
      ? handleApolloResponse(data.data.resetClinicCarePlan)
      : { err: 'resetClinicCarePlan failed, response not received' }
  }
}
